import React, { Component } from 'react';
import { TextField, MenuItem, Button } from '@mui/material';
import { hasUserPermission } from '../../../PermissionsCheck/PermissionsCheck';

const filterSpacingStyle = { minWidth: '20%', marginRight: '2rem' };

class DropdownInput extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.query[props.settings.key] || props.settings.defaultValue };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    this.handleNotification();
  }

  componentWillReceiveProps(props) {
    let newValue = props.query[props.settings.key] || props.settings.defaultValue;
    if (newValue != this.state.value) {
      this.setState({ ...this.state, value: newValue });
    }
  }

  onChange = (newValue) => {
    this.setState({ ...this.state, value: newValue.target.value }, () => this.handleNotification());
  };

  handleNotification = () => {
    if (this.isQueryDifferentFromState()) {
      this.props.onChanged(
        {
          [this.props.settings.key]: this.state.value,
        },
        this.props.settings
      );
    }
  };

  isQueryDifferentFromState = () => {
    return !this.state || this.state.value != this.props.query[this.props.settings.key];
  };

  render() {
    return (
      <TextField
        variant="standard"
        select={true}
        onChange={this.onChange}
        label={this.props.settings.displayName}
        value={this.state.value}
        data-qa={`qa-ddFilter-${this.props.settings.name}`}
        style={filterSpacingStyle}
      >
        {this.props.settings.options
          .filter((option) =>
            option.hasOwnProperty('allowedPermissions')
              ? hasUserPermission(option.allowedPermissions)
              : true
          )
          .map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
      </TextField>
    );
  }
}

export default DropdownInput;
